var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 22.75C6.80008 22.75 2.58008 18.52 2.58008 13.33C2.58008 8.14002 6.80008 3.90002 12.0001 3.90002C13.0701 3.90002 14.1101 4.05002 15.1101 4.36002C15.5101 4.48002 15.7301 4.90002 15.6101 5.30002C15.4901 5.70002 15.0701 5.92002 14.6701 5.80002C13.8201 5.54002 12.9201 5.40002 12.0001 5.40002C7.63008 5.40002 4.08008 8.95002 4.08008 13.32C4.08008 17.69 7.63008 21.24 12.0001 21.24C16.3701 21.24 19.9201 17.69 19.9201 13.32C19.9201 11.74 19.4601 10.22 18.5901 8.92002C18.3601 8.58002 18.4501 8.11002 18.8001 7.88002C19.1401 7.65002 19.6101 7.74002 19.8401 8.09002C20.8801 9.64002 21.4301 11.45 21.4301 13.33C21.4201 18.52 17.2001 22.75 12.0001 22.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1304 6.07003C15.9204 6.07003 15.7104 5.98003 15.5604 5.81003L12.6704 2.49003C12.4004 2.18003 12.4304 1.70003 12.7404 1.43003C13.0504 1.16003 13.5304 1.19003 13.8004 1.50003L16.6904 4.82003C16.9604 5.13003 16.9304 5.61003 16.6204 5.88003C16.4904 6.01003 16.3104 6.07003 16.1304 6.07003Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7602 8.53002C12.5302 8.53002 12.3002 8.42002 12.1502 8.22002C11.9102 7.89002 11.9802 7.42002 12.3102 7.17002L15.6802 4.71002C16.0102 4.46002 16.4802 4.54002 16.7302 4.87002C16.9802 5.20002 16.9002 5.67002 16.5702 5.92002L13.2002 8.39002C13.0702 8.49002 12.9202 8.53002 12.7602 8.53002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate-right.39d08fcfbee4e2086e8d89a5946aede8.svg";
export { ForwardRef as ReactComponent };